/* TC60 · Variation 2 — collage, voices marquee, bundle calculator.
   Pairs with tc60.js (reveal / count-up / sticky bar / mock form).
   Respects prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* duotone stand-ins for real photography (same language as the base mockup) */
  var GRADS = [
    'linear-gradient(135deg,#2B5561,#3D798A)',
    'linear-gradient(135deg,#BF6A15,#F3BF82)',
    'linear-gradient(135deg,#2F3335,#3D798A)',
    'linear-gradient(135deg,#D95004,#E29C56)',
    'linear-gradient(135deg,#3a4045,#747B7F)',
    'linear-gradient(135deg,#2B5561,#98A2A7)'
  ];

  /* ---- hero collage: two rows, each duplicated so the loop is seamless ---- */
  var TAGS = [
    'Customer · 1998', 'Staff · 22 yrs', 'Partner · Sonos', 'Customer · 2011',
    'Staff · 8 yrs', 'Partner · Marshall', 'Customer · 1986', 'Staff · 15 yrs',
    'Partner · B&W', 'Customer · 2023', 'Staff · 30 yrs', 'Customer · 2004',
    'Partner · Denon', 'Customer · 1979', 'Staff · 11 yrs', 'Customer · 2016'
  ];
  function buildRow(row, n, offset) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var t = document.createElement('div');
      t.className = 'collage-tile';
      t.style.backgroundImage = GRADS[(i + offset) % GRADS.length];
      var tag = document.createElement('span');
      tag.className = 'tag';
      tag.textContent = TAGS[(i + offset) % TAGS.length];
      t.appendChild(tag);
      frag.appendChild(t);
    }
    row.appendChild(frag);
  }
  document.querySelectorAll('.collage-row').forEach(function (row, ri) {
    var n = 9;
    buildRow(row, n, ri * 4);
    // duplicate the set so translateX(-50%) wraps invisibly
    buildRow(row, n, ri * 4);
  });

  /* ---- voices marquee: duplicate track content for seamless -50% loop ---- */
  document.querySelectorAll('.voices-track').forEach(function (track) {
    if (reduce) return; // static list is fine when motion is reduced
    track.innerHTML += track.innerHTML;
  });
  // give avatars a duotone fill
  document.querySelectorAll('.voice .av').forEach(function (av, i) {
    av.style.backgroundImage = GRADS[i % GRADS.length];
  });

  /* ---- path card backgrounds (duotone placeholders) ---- */
  document.querySelectorAll('.path[data-ph]').forEach(function (p) {
    p.style.setProperty('--x', '');
  });

  /* ---- bundle calculator ---- */
  var DISCOUNT = 0.20; // anniversary 20% off
  var money = function (n) { return '$' + n.toLocaleString('en-SG'); };
  var calc = document.querySelector('.bundle');
  if (calc) {
    var chips = calc.querySelectorAll('.bundle-chip');
    var linesEl = calc.querySelector('#receipt-lines');
    var subEl = calc.querySelector('#r-sub');
    var saveEl = calc.querySelector('#r-save');
    var grandEl = calc.querySelector('#r-grand');
    var countEl = calc.querySelector('#r-count');

    function flash(el) {
      if (reduce || !el) return;
      el.classList.add('flash');
      setTimeout(function () { el.classList.remove('flash'); }, 180);
    }

    function render() {
      var picked = [];
      chips.forEach(function (c) {
        if (c.getAttribute('aria-pressed') === 'true') {
          picked.push({ name: c.dataset.name, brand: c.dataset.brand, price: parseInt(c.dataset.price, 10) });
        }
      });
      // receipt lines
      linesEl.innerHTML = '';
      if (!picked.length) {
        var e = document.createElement('div');
        e.className = 'empty';
        e.textContent = 'Pick a product from any brand to start your bundle →';
        linesEl.appendChild(e);
      } else {
        picked.forEach(function (p) {
          var row = document.createElement('div');
          row.className = 'line';
          row.innerHTML = '<span>' + p.name + ' <em style="color:rgba(255,255,255,.5);font-style:normal">· ' + p.brand + '</em></span><span>' + money(p.price) + '</span>';
          linesEl.appendChild(row);
        });
      }
      var sub = picked.reduce(function (a, p) { return a + p.price; }, 0);
      // cross-brand bonus: 3+ brands unlocks a little extra celebration framing
      var brands = {}; picked.forEach(function (p) { brands[p.brand] = 1; });
      var crossBrand = Object.keys(brands).length >= 3;
      var rate = DISCOUNT + (crossBrand ? 0.05 : 0); // 25% when all three brands are in
      var save = Math.round(sub * rate);
      var grand = sub - save;

      flash(subEl); flash(saveEl); flash(grandEl);
      subEl.textContent = money(sub);
      saveEl.textContent = '– ' + money(save);
      grandEl.textContent = money(grand);
      countEl.textContent = picked.length + (picked.length === 1 ? ' item' : ' items') +
        (crossBrand ? ' · all 3 brands — +5% cross-brand bonus 🎉' : '');
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', on ? 'false' : 'true');
        render();
      });
    });
    render();
  }
})();
